import { IRequestConfig } from 'models/Axios';
import { IPaymentMethods, IPaymentMethodsData } from 'models/PaymentMethod';
import { QuotationOrigin } from 'components/Table/interface';

import axios from 'axios';
import Services from './index.service';


export class PaymentMethodServices extends Services<IPaymentMethodsData, IPaymentMethods> {
  getPaymentMethodListByName = (origin: QuotationOrigin, name?: string) => {
    let query = '';
    if (name === undefined) {
      query = '';
    }

    const config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/PaymentMethod/find-by-name/${query}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        origin: origin,
      },
    };

    return axios(config);
  };
}
